module.exports = __webpack_public_path__ + "static/media/comprovativo_info_icon.f7a17902.svg";